export const DESC_SORT = 'Desc';
export const ASC_SORT = 'Asc';
export type SortOptions = 'Desc' | 'Asc';
